export const markers = {
  black: {
    fillColor: '#000000',
    id: 'marker-cop-black',
    outlineColor: '#000000'
  },
  red: {
    fillColor: '#DC143C',
    id: 'marker-cop-red',
    outlineColor: '#DC143C'
  },
  templateName: 'marker'
};
